import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageUsersEditPage } from './manage-users-edit.page';

const routes: Routes = [
  {
    path: '',
    component: ManageUsersEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageUsersEditPageRoutingModule {}
